import React, {Component} from "react"
import PropTypes from "prop-types"
import {Route, NavLink as Link} from "react-router-dom"

import PageHelmet from "../organisms/PageHelmet"
import Info from '../pages/Info';
import LoadingIndicator from '../atoms/LoadingIndicator';
import Logout from '../molecules/Logout';
import Footer from '../organisms/Footer';
import Stag from '../organisms/Stag';
import NewStag from '../organisms/NewStag';
import Login from '../organisms/Login';
import MyStags from '../organisms/MyStags';
import OfflineStatus from '../organisms/OfflineStatus';

import "./App.css"
import LOGO from '../../assets/logo.png';

class App extends Component {
  componentWillMount() {
    this.props.checkAuthStatus()
    this.props.registerOnlineListener();
    this.props.registerAuthListener();
    this.props.registerUserStagsListener();
    if (this.props.authenticated && this.props.networkStatus) {
      this.props.getUserStags()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.networkStatus && ((nextProps.authenticated && !this.props.authenticated) || (!this.props.networkStatus)) ) {
      this.props.getUserStags()
    }
  }

  render() {
    const {authenticated, networkStatus, checkingAuthStatus, checkingNetworkStatus, newContentAvailable} = this.props;
    const selectedStag = !!this.props.location.pathname.match(/\/stag\/.+/);
    const homepage = ((this.props.location.pathname.indexOf('/new') === 0 || this.props.location.pathname.indexOf('/stag') === 0 || this.props.location.pathname.replace('/', '') === "") && !selectedStag)

    if ( checkingAuthStatus || checkingNetworkStatus ) {
      return (
        <div className="App"> <LoadingIndicator /> </div>
      )
    }

    return (
      <div className={
        "App"
        + (authenticated ? " user-authenticated" : "")
        + (!networkStatus ? " user-offline" : "")
        + (newContentAvailable ? " new-content-available" : "")
      }>

        <PageHelmet />

        {authenticated &&
          <div className="PageHeader">
            <div className="brand-logo">
              <Link className="home" to="/">
                <img
                  src={LOGO}
                  alt="Logo"
                />
              </Link>
            </div>
            <Logout />
          </div>}

        <OfflineStatus />

        {homepage &&
          <div>
            <div className="MastHead">
              {!authenticated &&
                <div className="brand-logo">
                  <Link className="home" to="/">
                    <img
                      src={LOGO}
                      alt="Logo"
                    />
                  </Link>
                </div>}
            </div>
            {authenticated &&
              <div style={{marginTop: "100px"}}>
                <Link to="/new" className="Link" activeClassName="active">
                  Create Stag
                </Link>
                <Link to="/stag" className="Link" activeClassName="active">
                  Join Stag
                </Link>
              </div>}
          </div>}

        {!authenticated
          ? <div style={{marginTop: "100px"}}>
              <Login />
            </div>
          : <div>
              <Route path="/stag/:selectedStag?" component={Stag} />
              <Route exact path="/new" component={NewStag} />
              <Route exact path="/info" component={Info} />
            </div>
        }

        {homepage && authenticated &&
          <div>
            <MyStags />
          </div>}

        <Footer />
      </div>
    )
  }
}

App.propTypes = {
  checkAuthStatus: PropTypes.func.isRequired,
  getUserStags: PropTypes.func.isRequired,
  registerOnlineListener: PropTypes.func.isRequired,
  registerAuthListener: PropTypes.func.isRequired,
  registerUserStagsListener: PropTypes.func.isRequired,
  authenticated: PropTypes.bool.isRequired,
  checkingAuthStatus: PropTypes.bool.isRequired,
  networkStatus: PropTypes.bool.isRequired,
  checkingNetworkStatus: PropTypes.bool.isRequired,
  newContentAvailable: PropTypes.bool.isRequired,
  contentCached: PropTypes.bool.isRequired,
}

// App Container is already wrapped by withRouter
export default App



// WEBPACK FOOTER //
// ./src/component/App/component.js